import getPKFromID from 'utilities/getPKFromID';

// Abstract class for models that represent graphql nodes.
class AbstractModelType {
  #id;

  constructor(properties = {}) {
    this.#id = properties.id;
  }

  get id() {
    return this.#id;
  }

  // Provide automatic conversion to primary key given an id.
  get pk() {
    return this.#id ? getPKFromID(this.#id) : null;
  }
}

export default AbstractModelType;
